module.exports = __webpack_public_path__ + "c3881903ce7d7a946122fa37895b7b06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-clown-s.png
// module id = 1896
// module chunks = 0